import { Customer } from "../models/customer";
import { uniqueArray } from "./uniqueArray";

/**
 * A function that recive a array of customers and returns an object of an array of
 * emails and phones
 *
 * @param {Customer[]} customers
 * @returns {<{ emails: string[], phones: string[]}>} An object of array of emails
 * and array of phones
 */
export const getEmailAndPhoneFromCustomer = (customers?: Customer[]) => {
  if (customers) {
    const emails: string[] = [];
    const phones: string[] = [];

    customers.forEach((customer) => {
      if (customer.email && customer.email !== "") emails.push(customer.email);
      if (customer.phone && customer.phone !== "") phones.push(customer.phone);
    });

    return {
      emails: uniqueArray(emails),
      phones: uniqueArray(phones),
    };
  }

  return {};
};
